import styled, {css} from 'styled-components';
import {NavLink} from 'react-router-dom';

interface ItemProps {
  readonly xmargin?: string;
}

export const ActiveLink = styled(NavLink)<ItemProps>`
  display: inline-block;
  color: var(--DarkGray);
  padding: 10px 19px;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 19px;
  border-radius: 8px;
  text-decoration: none;
  transition: 0.3s ease;
  border: 1px solid var(--LightGray);
  background-color: linear-gradient(0deg, #fdfafafa, #fbffffff);

  &:hover {
    color: #ffffff;
    background-color: #cbcfdd;
  }

  &:active {
    color: #ffffff;
    background-color: #acb1c0;
  }

  ${props => {
    const resMargin = props.xmargin
      ? `
      margin-left: ${props.xmargin};
      margin-right: ${props.xmargin};
    `
      : '';

    return css`
       {
        ${resMargin}
      }
    `;
  }}
`;

export const ActiveButton = styled.a<ItemProps>`
  background: linear-gradient(0deg, rgba(250, 250, 250, 0.99) 0%, rgba(255, 255, 255, 0.99) 100%);
  border: 1px solid var(--LightGray);
  color: var(--DarkGray);
  text-decoration: none;
  transition: 0.3s ease;
  display: flex;
  align-items: center;
  border-radius: 8px;
  padding: 10px 19px;
  letter-spacing: 0;
  line-height: 19px;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;

  &:hover {
    color: #43484f;
    background-color: #cbcfdd;
  }

  &:active {
    color: #43484f;
    background-color: #acb1c0;
  }

  ${props => {
    const resMargin = props.xmargin
      ? `
      margin-left: ${props.xmargin};
      margin-right: ${props.xmargin};
    `
      : '';

    return css`
       {
        ${resMargin}
      }
    `;
  }}
`;

export const ActiveText = styled.span`
  white-space: nowrap;
  margin-left: 10px;
`;
